import React, { Fragment, useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import Spinner, { MiniSpinner } from '../../components/layouts/Spinner';
import Select from 'react-select';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import countryList from 'react-select-country-list';
import {
    handleInputChange,
    branchUpdate,
    handleSelectCountry,
    handleMobile,
    removeFileEdit,
    updateFile,
    getSingleBranch,
} from '../../redux/actions/branch/branch.actions';
import { Redirect } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';
import ReactTooltip from 'react-tooltip';
import { fileExtensionIcon } from '../../Utils/Common';
import { Link } from 'react-router-dom';
import { SwalFormWarning } from '../../Services/_swal.service';
import BeforeUnloadComponent from 'react-beforeunload-component';
import { useHistory, useLocation } from 'react-router-dom';
import { blockRoute } from '../../redux/actions/helper/helper.actions';

function BranchEdit({
    branch: {
        single_branch,
        main_page,
        main_url,
        mini_loading,
    },
    new_uploads,
    handleInputChange,
    branchUpdate,
    handleSelectCountry,
    handleMobile,
    isSearchable,
    removeFileEdit,
    updateFile,
    getSingleBranch,
    match,
    block_route,
    blockRoute,
}) {
    const [countryOptions, setCountryOptions] = useState('');
    const [countryValue, setCountryValue] = useState(
        single_branch.country || { value: 'PH', label: 'Philippines' }
    );
    const [mobileCountry, setMobileCountry] = useState(
        single_branch.country && single_branch.country.value
            ? single_branch.country.value.toLowerCase()
            : 'ph'
    );

    useEffect(() => {
        setCountryValue(single_branch.country);
        if (single_branch.country && single_branch.country.value) {
            setMobileCountry(single_branch.country.value.toLowerCase());
        }
    }, [single_branch.country]);

    const onDrop = useCallback((acceptedFiles) => {
        updateFile(acceptedFiles);
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    const history = useHistory();

    useEffect(() => {
        blockRoute(false);
    }, []);

    useEffect(() => {
        if (countryOptions == '') {
            setCountryOptions(countryList().getData());
        }
        getSingleBranch(match.params.id);
    }, [countryOptions]);

    useEffect(() => {
        window.addEventListener('beforeunload', function (e) {
            delete e['returnValue'];
            blockRoute(false);
        });

        if (block_route) {
            window.history.pushState(null, null, window.location.pathname);
            window.addEventListener('popstate', onBackButtonEvent);
        }

        return () => {
            window.removeEventListener('popstate', onBackButtonEvent);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [block_route]);

    const onBackButtonEvent = (e) => {
        e.preventDefault();
        if (block_route) {
            SwalFormWarning(
                'Warning',
                'Do you want to leave without saving',
                () => goLastLocation(),
                () => blockAgain()
            );
        }
    };

    const goLastLocation = () => {
        history.goBack();
        blockRoute(false);
    };

    const blockAgain = () => {
        window.history.pushState(null, null, window.location.pathname);
    };

    if (main_page) return <Redirect to={main_url} />;

    return (
        <BeforeUnloadComponent
            ignoreBeforeunloadDocument={true}
            blockRoute={block_route}
            modalComponentHandler={({ handleModalLeave, handleModalCancel }) => {
                SwalFormWarning(
                    'Warning',
                    'Do you want to leave without saving',
                    () => handleModalLeave(),
                    () => handleModalCancel()
                );
            }}
        >
            <div className="app-content content">
                <div className="content-wrapper">
                    <div className="content-wrapper-before"></div>
                    <div className="content-header row">
                        <div className="content-header-left col-md-12 col-12 mb-2 breadcrumb-new fix-header">
                            <h3 className="content-header-title mb-0 d-inline-block">
                                Inventory
                            </h3>
                            <div className="breadcrumbs-top d-inline-block">
                                <div className="breadcrumb-wrapper mr-1">
                                    <ol className="breadcrumb f-regular">
                                        <li className="breadcrumb-item">
                                            <a href={main_url} className="text-white">
                                                Branches
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <a href="#" className="text-white">
                                                View
                                            </a>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content-body margin-top-5">
                        <section id="basic-examples">
                            <div className="row f-regular">
                                <div className="col-md-12 col-sm-12 col-lg-12 col-xl-9">
                                    <div className="card">
                                        <div className="card-header mb-0 pb-0">
                                            <Link to={main_url}>
                                                <i className="ft ft-arrow-left"></i> Back
                                            </Link>
                                        </div>
                                        <div className="card-content collapse show">
                                            <div className="card-body f-regular">
                                                {mini_loading ? (
                                                    <MiniSpinner />
                                                ) : (
                                                    <div>
                                                        <ReactTooltip effect="solid" event="click" />
                                                        <div className="row">
                                                            {/* Name */}
                                                            <div className="col-12 col-md-6 col-sm-12">
                                                                <label className="label-control">
                                                                    Name:{' '}
                                                                    <span className="text-danger">*</span>
                                                                </label>
                                                                <div className="form-group row">
                                                                    <div className="col-md-11 col-10">
                                                                        <input
                                                                            type="text"
                                                                            value={single_branch.name || ''}
                                                                            name="name"
                                                                            className="form-control f-regular"
                                                                            placeholder="Name"
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                    <div className="float-right pl-0 col-1 col-md-1">
                                                                        <div className="input-group-prepend">
                                                                            <span href="#" className="tool-tip text-primary" data-tip="this is a tool tip">
                                                                                <i className="la la-question-circle"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Business Name */}
                                                            <div className="col-12 col-md-6">
                                                                <label className="label-control">Business Name: </label>
                                                                <div className="form-group row">
                                                                    <div className="col-md-11 col-10">
                                                                        <input
                                                                            type="text"
                                                                            value={single_branch.business_name || ''}
                                                                            name="business_name"
                                                                            className="form-control f-regular"
                                                                            placeholder="Business Name"
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                    <div className="float-right pl-0 col-1 col-md-1">
                                                                        <div className="input-group-prepend">
                                                                            <span href="#" className="tool-tip text-primary" data-tip="this is a tool tip">
                                                                                <i className="la la-question-circle"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Street 1 */}
                                                            <div className="col-12 col-md-6">
                                                                <label className="label-control">Street 1: </label>
                                                                <div className="form-group row">
                                                                    <div className="col-md-11 col-10">
                                                                        <textarea
                                                                            value={single_branch.street1 || ''}
                                                                            name="street1"
                                                                            rows="3"
                                                                            className="form-control f-regular"
                                                                            placeholder="Street 1"
                                                                            disabled
                                                                        ></textarea>
                                                                    </div>
                                                                    <div className="float-right pl-0 col-1 col-md-1">
                                                                        <div className="input-group-prepend">
                                                                            <span href="#" className="tool-tip text-primary" data-tip="this is a tool tip">
                                                                                <i className="la la-question-circle"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Street 2 */}
                                                            <div className="col-12 col-md-6">
                                                                <label className="label-control">Street 2: </label>
                                                                <div className="form-group row">
                                                                    <div className="col-md-11 col-10">
                                                                        <textarea
                                                                            value={single_branch.street2 || ''}
                                                                            name="street2"
                                                                            rows="3"
                                                                            className="form-control f-regular"
                                                                            placeholder="Street 2"
                                                                            disabled
                                                                        ></textarea>
                                                                    </div>
                                                                    <div className="float-right pl-0 col-1 col-md-1">
                                                                        <div className="input-group-prepend">
                                                                            <span href="#" className="tool-tip text-primary" data-tip="this is a tool tip">
                                                                                <i className="la la-question-circle"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* City */}
                                                            <div className="col-12 col-md-6">
                                                                <label className="label-control">City: </label>
                                                                <div className="form-group row">
                                                                    <div className="col-md-11 col-10">
                                                                        <input
                                                                            type="text"
                                                                            value={single_branch.city || ''}
                                                                            name="city"
                                                                            className="form-control f-regular"
                                                                            placeholder="City"
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                    <div className="float-right pl-0 col-1 col-md-1">
                                                                        <div className="input-group-prepend">
                                                                            <span href="#" className="tool-tip text-primary" data-tip="this is a tool tip">
                                                                                <i className="la la-question-circle"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* State/Region */}
                                                            <div className="col-12 col-md-6">
                                                                <label className="label-control">State/Region: </label>
                                                                <div className="form-group row">
                                                                    <div className="col-md-11 col-10">
                                                                        <input
                                                                            type="text"
                                                                            value={single_branch.state || ''}
                                                                            name="state"
                                                                            className="form-control f-regular"
                                                                            placeholder="State/Region"
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                    <div className="float-right pl-0 col-1 col-md-1">
                                                                        <div className="input-group-prepend">
                                                                            <span href="#" className="tool-tip text-primary" data-tip="this is a tool tip">
                                                                                <i className="la la-question-circle"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Country */}
                                                            <div className="col-12 col-md-6">
                                                                <label className="label-control">Country: </label>
                                                                <div className="form-group row">
                                                                    <div className="col-md-11 col-10">
                                                                        <Select
                                                                            options={countryOptions}
                                                                            value={countryValue}
                                                                            isSearchable={isSearchable}
                                                                            name="country"
                                                                            isDisabled={true}
                                                                        />
                                                                    </div>
                                                                    <div className="float-right pl-0 col-1 col-md-1">
                                                                        <div className="input-group-prepend">
                                                                            <span href="#" className="tool-tip text-primary" data-tip="this is a tool tip">
                                                                                <i className="la la-question-circle"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Landline */}
                                                            <div className="col-12 col-md-6">
                                                                <label className="label-control">Landline: </label>
                                                                <div className="form-group row">
                                                                    <div className="col-md-11 col-10">
                                                                        <input
                                                                            type="number"
                                                                            value={single_branch.landline || ''}
                                                                            name="landline"
                                                                            className="form-control f-regular"
                                                                            placeholder="Landline"
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                    <div className="float-right pl-0 col-1 col-md-1">
                                                                        <div className="input-group-prepend">
                                                                            <span href="#" className="tool-tip text-primary" data-tip="this is a tool tip">
                                                                                <i className="la la-question-circle"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Mobile */}
                                                            <div className="col-12 col-md-6">
                                                                <label className="label-control">Mobile: </label>
                                                                <div className="form-group row">
                                                                    <div className="col-md-11 col-10">
                                                                        <PhoneInput
                                                                            countryCodeEditable={false}
                                                                            enableSearch="true"
                                                                            value={single_branch.mobile ? single_branch.mobile : ''}
                                                                            country={mobileCountry}
                                                                            inputProps={{
                                                                                name: 'mobile',
                                                                                required: false,
                                                                                autoFormat: true,
                                                                                enableSearch: true,
                                                                            }}
                                                                            inputClass="react-mobile-input w-100"
                                                                            placeholder=""
                                                                            masks={{ ph: '... ... ....' }}
                                                                            disabled={true}
                                                                        />
                                                                    </div>
                                                                    <div className="float-right pl-0 col-1 col-md-1">
                                                                        <div className="input-group-prepend">
                                                                            <span href="#" className="tool-tip text-primary" data-tip="this is a tool tip">
                                                                                <i className="la la-question-circle"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Fax */}
                                                            <div className="col-12 col-md-6">
                                                                <label className="label-control">Fax: </label>
                                                                <div className="form-group row">
                                                                    <div className="col-md-11 col-10">
                                                                        <input
                                                                            type="number"
                                                                            value={single_branch.fax || ''}
                                                                            name="fax"
                                                                            className="form-control f-regular"
                                                                            placeholder="Fax"
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                    <div className="float-right pl-0 col-1 col-md-1">
                                                                        <div className="input-group-prepend">
                                                                            <span href="#" className="tool-tip text-primary" data-tip="this is a tool tip">
                                                                                <i className="la la-question-circle"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* TIN */}
                                                            <div className="col-12 col-md-6">
                                                                <label className="label-control">TIN: </label>
                                                                <div className="form-group row">
                                                                    <div className="col-md-11 col-10">
                                                                        <input
                                                                            type="number"
                                                                            value={single_branch.tin || ''}
                                                                            name="tin"
                                                                            className="form-control f-regular"
                                                                            placeholder="TIN"
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                    <div className="float-right pl-0 col-1 col-md-1">
                                                                        <div className="input-group-prepend">
                                                                            <span href="#" className="tool-tip text-primary" data-tip="this is a tool tip">
                                                                                <i className="la la-question-circle"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Email */}
                                                            <div className="col-12 col-md-6">
                                                                <label className="label-control">Email: </label>
                                                                <div className="form-group row">
                                                                    <div className="col-md-11 col-10">
                                                                        <input
                                                                            type="email"
                                                                            value={single_branch.email || ''}
                                                                            name="email"
                                                                            className="form-control f-regular"
                                                                            placeholder="Email"
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                    <div className="float-right pl-0 col-1 col-md-1">
                                                                        <div className="input-group-prepend">
                                                                            <span href="#" className="tool-tip text-primary" data-tip="this is a tool tip">
                                                                                <i className="la la-question-circle"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Contact Person */}
                                                            <div className="col-12 col-md-6">
                                                                <label className="label-control">Contact Person: </label>
                                                                <div className="form-group row">
                                                                    <div className="col-md-11 col-10">
                                                                        <input
                                                                            type="text"
                                                                            value={single_branch.contact_person || ''}
                                                                            name="contact_person"
                                                                            className="form-control f-regular"
                                                                            placeholder="Contact Person"
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                    <div className="float-right pl-0 col-1 col-md-1">
                                                                        <div className="input-group-prepend">
                                                                            <span href="#" className="tool-tip text-primary" data-tip="this is a tool tip">
                                                                                <i className="la la-question-circle"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </BeforeUnloadComponent>
    );
}

const mapStateToProps = (state) => ({
    branch: state.branch,
    new_uploads: state.branch.new_uploads,
    isSearchable: state.branch.isSearchable,
    block_route: state.helper.block_route,
});

export default connect(mapStateToProps, {
    handleInputChange,
    branchUpdate,
    handleSelectCountry,
    handleMobile,
    removeFileEdit,
    updateFile,
    getSingleBranch,
    blockRoute,
})(BranchEdit);
